import React from "react";
import {
  Breadcrumbs,
  BreadcrumbItem,
} from "@amzn/squad-front-end-shared-react-components";
import { TeamDtoWithBreadcrumb } from "../../layout/subheader/SubHeaderDto";

interface TeamsReportsToBreadcrumbsProps {
  data: TeamDtoWithBreadcrumb | undefined;
}

const TeamsReportsToBreadcrumbs: React.FC<TeamsReportsToBreadcrumbsProps> = ({
  data,
}): JSX.Element => {
  const breadcrumbItems: BreadcrumbItem[] =
    data?.breadcrumbs?.map((breadcrumbData) => ({
      name: breadcrumbData.name,
      link: `/team/${breadcrumbData.teamId}`,
    })) ?? [];

  return <Breadcrumbs breadcrumbItems={breadcrumbItems} />;
};

export default TeamsReportsToBreadcrumbs;
